import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { Bau365DataAccessUserModule } from '@planone/bau365/data-access-user';

import { FilterResolver } from './filter-resolver/filter.resolver';
import { SearchResolver } from './search-resolver/search.resolver';
import { DataAccessSearchService } from './service/data-access-search.service';
import * as fromSearchFilterOptionsCurrent from './state/option-ids-selectable/option-ids-selectable.reducer';
import * as fromSearchFilterOptionsInitial from './state/option-ids-visible/option-ids-visible.reducer';
import { OptionLabelsEffects } from './state/option-labels/option-labels.effects';
import { OptionLabelsFacade } from './state/option-labels/option-labels.facade';
import * as fromSearchFilterLabels from './state/option-labels/option-labels.reducer';
import { OptionsFacade } from './state/options-facade/options.facade';
import { DataAccessSearchPageFacade } from './state/page/data-access-search.page.facade';
import { DataAccessSearchEffects } from './state/search-results/data-access-search.effects';
import { DataAccessSearchFacade } from './state/search-results/data-access-search.facade';
import * as fromDataAccessSearch from './state/search-results/data-access-search.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromDataAccessSearch.DATA_ACCESS_SEARCH_RESULTS_FEATURE_KEY, fromDataAccessSearch.reducer),
    EffectsModule.forFeature([DataAccessSearchEffects]),
    StoreModule.forFeature(
      fromSearchFilterOptionsInitial.OPTION_IDS_VISIBLE_FEATURE_KEY,
      fromSearchFilterOptionsInitial.optionIdsVisibleReducer
    ),
    StoreModule.forFeature(
      fromSearchFilterOptionsCurrent.OPTION_IDS_SELECTABLE_FEATURE_KEY,
      fromSearchFilterOptionsCurrent.optionIdsSelectableReducer
    ),
    StoreModule.forFeature(
      fromSearchFilterLabels.OPTION_LABELS_FEATURE_KEY,
      fromSearchFilterLabels.optionLabelsReducer
    ),
    EffectsModule.forFeature([OptionLabelsEffects]),
    Bau365DataAccessUserModule,
  ],
  providers: [
    DataAccessSearchFacade,
    DataAccessSearchPageFacade,
    DataAccessSearchService,
    FilterResolver,
    SearchResolver,
    OptionsFacade,
    OptionLabelsFacade,
  ],
})
export class Bau365DataAccessSearchModule {}
